import React, { useState, useEffect } from 'react';
import styles from './viewReferenceCheckGroup.module.scss';
import ReactGA from 'react-ga4';
import { Helmet } from "react-helmet";
import CustomNavbar from '../../customNavbar';
import { Accordion, Card, Col, Row, Button } from 'react-bootstrap';
import { dropdownIcon } from '../../../shared/customIcons/Icons';
import CSSLoader from '../../../shared/cssLoader';
import { getAllReferenceCheckGroupDetails } from '../../../../services/util/referenceCheck';
import { CustomAlertBox } from '../../../shared/customAlertBox';
import { CustomPreIcon } from '../../../shared/customPreIcon';
import { CustomSearch } from '../../../shared/customSearch';
import { CustomButton } from '../../../shared/customButton';
import Avatar from 'react-avatar';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { useNavigate } from 'react-router-dom';
import { CustomStatusLabel } from '../../../shared/customStatusLabel';
import { requestRefereeDetailsFromCandidate } from '../../../../services/util/hiringpipeline/emailAutomation';
import { toast } from 'react-toastify';

function ViewReferenceCheckGroup(props) {
    let [accordionIcon, setAccordionIcon] = useState(true);
    let [candidateList, setCandidateList] = useState([]);
    let [commonData, setCommonData] = useState({});
    let [isURLLoading, setURLLoading] = useState(false);
    const [isLoading, setLoading] = useState(false);
    let [getUsersIsLoading, getUsersSetLoading] = useState(false);
    let [defaultStateType, setDefaultStateType] = useState({
        label: "All",
        value: 100
    })

    const history = useNavigate();

    const breadcrumb = [
        {
            pathaddress: '/app/company/reference-checks',
            pathname: 'Reference Checks',
            isActive: false,
            key: 1 + 'Reference Check'
        },
        {
            pathaddress: '',
            pathname: commonData.step_name,
            isActive: true,
            key: 1 + commonData.step_name
        }
    ];

    const animatedComponents = makeAnimated();

    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);

    let step_id = (params.get('step_id') ? params.get('step_id') : null);
    let seleted_state = (params.get('state') ? params.get('state') : 100);

    //dropdown reference status types
    const StateTypes = [
        {
            label: "All",
            value: 100
        },
        {
            label: "Referee details received",
            value: 5
        },
        {
            label: "Waiting for reference details",
            value: 3
        },
        {
            label: "Ready to request referee details",
            value: 0
        },

    ];

    const changeReferencetStatusType = async (type) => {
        setLoading(true);
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let step_id = params.get('step_id');
        setDefaultStateType(type);
        let respond = await getAllReferenceCheckGroupDetails(step_id, type.value);
        if (respond.success == true) {
            setCommonData(respond.data.common_details);
            setCandidateList(respond.data.candidate_object_list);
            setCandidateList(respond.data.candidate_object_list);
            setLoading(false);
        }
    }

    const changeSelectedStateURL = async (state) => {
        history({
            pathname: `/company/reference-checks/group`,
            search: `?step_id=${step_id}&state=${state}`,

        });
    }

    const changeAccordionIcon = () => {
        setAccordionIcon(!accordionIcon)
    }

    const viewReferenceCheck = (values) => {
        props.history(`/company/reference-checks/${values}`);
    }

    async function loadInitialData() {
        setLoading(true);
        //getting query parameter value
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let step_id = params.get('step_id');
        let selectedState = parseInt(seleted_state)
        if (step_id) {
            let respond = await getAllReferenceCheckGroupDetails(step_id, selectedState);

            if (respond.success === true) {
                if (respond.data && respond.data.common_details && respond.data.candidate_object_list) {
                    setCommonData(respond.data.common_details);
                    setCandidateList(respond.data.candidate_object_list);
                    //setting statelabel for selected state
                    if (selectedState != 100) {
                        for (let index = 0; index < StateTypes.length; index++) {
                            if (StateTypes[index].value == selectedState) {
                                setDefaultStateType(StateTypes[index]);

                            }
                        }
                    }

                    setLoading(false);
                } else {
                    if (selectedState === 0 || selectedState === 5) {
                        history({
                            pathname: `/company/reference-checks/group`,
                            search: `?step_id=${step_id}&state=${100}`,

                        });
                    } else {
                        props.history('/company/reference-checks');
                    }

                }
            } else {
                props.history(`/company/reference-checks`);
                setLoading(false);
            }
        }
    }

    //searching assessments
    function searchValues(searchValue) {
        let searchVal = searchValue.toLowerCase();
        if (searchValue == '') {
            loadInitialData()
            setCandidateList(candidateList)
        } else {
            const filtered = candidateList.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
            setCandidateList(filtered);
        }

    }

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(candidateList.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(candidateList.length / itemsPerPage);

    const sendRequestRefereeDetailsFromCandidate = async (respond) => {
        try {
            const response = await requestRefereeDetailsFromCandidate( 
                respond.reference_check_session_id,
                respond.candidate_name,
                respond.candidate_email,
                commonData.company_name,
                commonData.hiring_position,
                commonData.contact_email,
              );
    
            if (response.success) {
                toast.success(<div>Email Sent Successfully.</div>, {
                    position: "top-right",
                    autoClose: 2500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            toast.error(<div>Failed to send email.</div>, {
                position: "top-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        loadInitialData()
    };

    useEffect(() => {
        loadInitialData();
    }, [])

    useEffect(() => {
        let pageHit = '/app/company/reference-checks';
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: pageHit});
    }, [])

    return (
        <div>
            <Helmet>
                <title>Reference Check| HireTrace</title>
            </Helmet>
            {isLoading ?
                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>

                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>

                    <div className={styles.BodyContainer}>
                        <Col>
                            <Col>
                                <div>
                                    <Row className='ms-2 me-1'>
                                        <Col sm={3} className={styles.PipelineDetailsCol}>
                                            <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Pipeline : </span><span className={styles.reviewDetailsValue}>{commonData.pipeline_name}</span></p>
                                            <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Position : </span><span className={styles.reviewDetailsValue}>{commonData.hiring_position}</span></p>
                                        </Col>
                                        <Col sm={3} className="mb-2">
                                            <Select
                                                options={StateTypes}
                                                class="react-select__control"
                                                components={animatedComponents}
                                                value={defaultStateType}
                                                onChange={(e) => {
                                                    changeReferencetStatusType(e);
                                                    changeSelectedStateURL(e.value)
                                                }}
                                                styles={
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #D0D5DD', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                            height: '44px',
                                                            fontFamily: 'var(--app-primary-font-style)',
                                                            fontWeight: 'var(--app-regular-font-weight)',
                                                            fontSize: 'var(--app-primary-font-size)',

                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                }
                                            />
                                        </Col>
                                        <Col sm={6} className="mb-2">
                                            <CustomSearch
                                                placeholder="Search by name"
                                                handleOnChange={(e) => searchValues(e.target.value)}
                                            />
                                        </Col>

                                    </Row>
                                </div>
                            </Col>

                            <div className={styles.tableContainer}>
                                <div className={styles.tableFirstRowMainHeaderDiv}>
                                    <Col sm={3} className={styles.tableDetailsMainHeaderRow}>
                                        <p>Candidate Details</p>
                                    </Col>
                                    <Col sm={2}>
                                        <Row className={styles.tableInfoDetailsMainHeaderRow}>
                                            <p className={styles.satesLable}>Status</p>
                                        </Row>
                                    </Col>
                                    <Col sm={2}>
                                        <Row className={styles.tableDetailsSecondHeaderRow}>
                                            <p>Passing Threshold</p>
                                        </Row>
                                    </Col>
                                    <Col sm={1}>
                                        <Row className={styles.tableDetailsSecondHeaderRow}>
                                            <p>Overall Marks</p>
                                        </Row>
                                    </Col>
                                    <Col sm={2}>
                                        <Row className={styles.tableDetailsSecondHeaderRow}>
                                            <p>Send Request</p>
                                        </Row>
                                    </Col>
                                    <Col sm={2}>
                                        <Row className={styles.tableReviewDetailsHeaderRow}>
                                            <p>Review</p>
                                        </Row>
                                    </Col>
                                </div>
                                {candidateList?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((referenceCheck, i) => {
                                    return (
                                        <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                            <Col sm={3}>
                                                <Row className={styles.tableJobDetailsMainRow}>
                                                    <Col sm={3}>
                                                        <Avatar name={referenceCheck.candidate_name} size="32" round={true} />
                                                    </Col>
                                                    <Col sm={9}>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableJobDetails}>{referenceCheck?.candidate_name}</p>
                                                        </Row>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableSecondJobDetails}>{referenceCheck?.candidate_email}</p>
                                                        </Row>
                                                    </Col>

                                                </Row>

                                            </Col>

                                            <Col sm={2}>
                                                <Row className='d-flex align-items-center justify-content-center mt-4 me-4'>
                                                <CustomStatusLabel type={referenceCheck.state === 5 || referenceCheck.state === 6 || referenceCheck.state === 7 ? 'successStatus' : referenceCheck.state === 3 || referenceCheck.state === 0 ? 'warningStatus' : 'dangerStatus'} label={referenceCheck.state === 5  ? 'Reference details received' : referenceCheck.state === 6 || referenceCheck.state === 7 ? 'Reviewer submitted referee details': referenceCheck.state === 3 ? 'Waiting for reference details': referenceCheck.state === 0 ? 'Pending for Request Mail Send' : referenceCheck.state === -40 ? 'Expired' : null}></CustomStatusLabel>
                                                </Row>
                                            </Col>
                                            <Col sm={2}>
                                                <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                    <p className={styles.tableCandidatesInfoDetails}>Pass | Fail</p>
                                                </Row>
                                            </Col>
                                            <Col sm={1}>
                                                <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                    {referenceCheck.candidate_overall_marks !== null ? (
                                                        <p className={styles.tableCandidatesInfoDetails}>
                                                            {referenceCheck.candidate_overall_marks.toFixed(0)}%
                                                        </p>
                                                    ) : (
                                                        <p className={styles.tableCandidatesInfoDetails}>N/A</p>
                                                    )}
                                                </Row>
                                            </Col>
                                            <Col sm={2}>
                                                <Row className={styles.tableCandidatesInfoDetailsButtonRow}>
                                                    { referenceCheck.is_auto_request_referee_details_from_candidate_enabled && (referenceCheck.state === 3 || referenceCheck.state === 5 || referenceCheck.state === 7)? (
                                                        <p className={styles.tableCandidatesInfoDetails}>
                                                            Auto Sent Request
                                                        </p>
                                                    ) :!referenceCheck.is_auto_request_referee_details_from_candidate_enabled && (referenceCheck.state === 3 || referenceCheck.state === 5 || referenceCheck.state === 7)?  (
                                                        <p className={styles.tableCandidatesInfoDetails}>
                                                            Sent Request Manually
                                                        </p>
                                                    ) : (
                                                        <CustomButton
                                                            buttonType="button"
                                                            label="Send Request"
                                                            type="successSmallBtn"
                                                            backicon={
                                                                <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M1 3.83337L7.8041 8.59624C8.35508 8.98193 8.63056 9.17477 8.93022 9.24946C9.19491 9.31544 9.47176 9.31544 9.73645 9.24946C10.0361 9.17477 10.3116 8.98193 10.8626 8.59624L17.6667 3.83337M5 14.6667H13.6667C15.0668 14.6667 15.7669 14.6667 16.3016 14.3942C16.772 14.1545 17.1545 13.7721 17.3942 13.3017C17.6667 12.7669 17.6667 12.0668 17.6667 10.6667V5.33337C17.6667 3.93324 17.6667 3.23318 17.3942 2.6984C17.1545 2.22799 16.772 1.84554 16.3016 1.60586C15.7669 1.33337 15.0668 1.33337 13.6667 1.33337H5C3.59987 1.33337 2.8998 1.33337 2.36502 1.60586C1.89462 1.84554 1.51217 2.22799 1.27248 2.6984C1 3.23318 1 3.93324 1 5.33337V10.6667C1 12.0668 1 12.7669 1.27248 13.3017C1.51217 13.7721 1.89462 14.1545 2.36502 14.3942C2.8998 14.6667 3.59987 14.6667 5 14.6667Z" stroke="#027A48" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                            }
                                                            handleClick={() => sendRequestRefereeDetailsFromCandidate(referenceCheck)}
                                                        />
                                                    )}
                                                </Row>

                                            </Col>
                                            <Col sm={2}>
                                                <Row className={styles.tableCandidatesInfoDetailsButtonRow}>
                                                    <CustomButton
                                                        buttonType="button"
                                                        label="Review"
                                                        type="secondaryBtn"
                                                        backicon={
                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M9 12L12 9L9 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M6 9H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        }
                                                        handleClick={() => viewReferenceCheck(referenceCheck.reference_check_session_id)}
                                                    />
                                                </Row>
                                            </Col>
                                        </div>
                                    );

                                })
                                }

                            </div>
                            {candidateList.length > 9 && getUsersIsLoading === false &&
                                <div className={styles.bottomTableDiv}>
                                    <div className={styles.bottomTableControlsWrapper}>
                                        <div className={styles.bottomTableControlsNextBtn}>
                                            <CustomButton
                                                id="reference_check_go_to_previous_page_btn"
                                                label="Previous"
                                                handleClick={handlePreviousClick}
                                                disabled={currentPage === 1}
                                                type="defaultSmallBtn"
                                            />
                                        </div>
                                        <div>
                                            <CustomButton
                                                id="reference_check_go_to_next_page_btn"
                                                label="Next"
                                                type="defaultSmallBtn"
                                                handleClick={handleNextClick}
                                                disabled={currentPage === Math.ceil(candidateList.length / itemsPerPage)}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <span className={styles.paginationInfo}>
                                            Page {currentPage} of {totalPages}
                                        </span>
                                    </div>

                                </div>
                                // <div className={styles.bottomTableDiv}>
                                //     <div>
                                //         <button
                                //             onClick={handlePreviousClick}
                                //             disabled={currentPage === 1}
                                //             className={styles.paginationPrevButton}
                                //         >
                                //             Previous
                                //         </button>
                                //         <button
                                //             onClick={handleNextClick}
                                //             disabled={currentPage === Math.ceil(candidateList.length / itemsPerPage)}
                                //             className={styles.paginationNextButton}
                                //         >
                                //             Next
                                //         </button>
                                //     </div>
                                //     <div>
                                //         <span className={styles.paginationInfo}>
                                //             Page {currentPage} of {totalPages}
                                //         </span>
                                //     </div>

                                // </div>
                            }
                        </Col>
                    </div>
                </div>
            }
        </div>
    )
}

export default ViewReferenceCheckGroup;
